import GLightbox from "glightbox";
import 'glightbox/dist/css/glightbox.css'
import { useEffect } from "react";

const useUkmPpg = () => {

    useEffect(() => {
        const lightbox = GLightbox({ selector: '.glightbox' });
        console.log(lightbox);
        
        return () => {
            lightbox.destroy();
        };
    }, [])

    return {}
}
export default useUkmPpg